module.exports = __webpack_public_path__ + "img/guide_btn.08551243.png";